module.exports = __webpack_public_path__ + "img/code-sandbox-circle.f004a008.svg";